import { EventArgs } from "./..";
export class PropertyChangedEventArgs extends EventArgs {
  get propertyName() {
    return this._propertyName;
  }

  constructor(_propertyName) {
    super();
    this._propertyName = _propertyName;
  }

}
